import {Component, Input} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

@Component({
  selector: 'app-category-cell',
  imports: [],
  templateUrl: './category-cell.component.html',
  styleUrl: './category-cell.component.scss'
})
export class CategoryCellComponent implements ICellRendererAngularComp {
  @Input() category?: string = '';

  agInit(params: any): void {
    this.setCategory(params);
  }

  refresh(params: ICellRendererParams<any>): boolean {
    this.setCategory(params);
    return false;
  }

  private setCategory(params: any): void {
    this.category = params?.category ?? params?.cellRendererParams?.color ?? this.category;
  }

}
